import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { api } from 'store/api';
import { setImpersonationViewOrganizationId, setSelectedOrganizationId } from 'store/organizations/reducers';
import { persistentTags, tags } from 'store/tags';
import { PersistService } from 'utils/persist';

const tagsToInvalidate = tags.filter((tag) => !(persistentTags as readonly string[]).includes(tag));

export const organizationListenerMiddleware = createListenerMiddleware();

organizationListenerMiddleware.startListening({
  matcher: isAnyOf(setSelectedOrganizationId, setImpersonationViewOrganizationId),
  effect: (_, { dispatch }) => {
    dispatch(api.util.invalidateTags([...tagsToInvalidate]));
  },
});

// `/session.isImpersonating` is the source of truth for whether the backend still honours
// X-Switch-User (see PD-3487) - if we're holding a persisted impersonated user but the server
// reports we're not impersonating, the header is stale/invalid. Clearing it here and letting the
// existing listener above invalidate the cache replaces the old approach of guessing "impersonation
// ended" from a bare 403 on any request, which false-positived on ordinary permission errors.
organizationListenerMiddleware.startListening({
  matcher: api.endpoints.getSession.matchFulfilled,
  effect: (action, { dispatch }) => {
    const isImpersonationStale = !!PersistService.getImpersonatedUser() && !action.payload.isImpersonating;

    if (!isImpersonationStale) return;

    PersistService.clearImpersonation();
    dispatch(setImpersonationViewOrganizationId(null));
  },
});
